import { OverlayId } from 'Types/types';
import { useConfig, useFeatureToggle } from 'AppShell/hooks';
import { CustomFeatureToggles } from 'AppShell/types';

export const useIsMultiStep = (): boolean => {
    const { shopToClubOverlayId } = useConfig();
    const featureToggles = useFeatureToggle();
    // TODO Handle multistep form as a feature flag
    return (
        shopToClubOverlayId === OverlayId.SHOP_TO_CLUB_REGISTRATION_MULTI_STEP_OVERLAY ||
        (featureToggles as CustomFeatureToggles & { isMultiStepForm: boolean }).isMultiStepForm
    );
};
